import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    sendTimeSheetLine({ commit }, timeSheetLine) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(Vue.prototype.apiUrl + "/api/users/sendTimeSheetLine", timeSheetLine)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },

  module: {},
  getters: {}
};
